// extracted by mini-css-extract-plugin
export default {"departments":"yH-z","departmentHeading":"zH-z","departmentSection":"AH-z","departmentName":"BH-z","departmentLink":"CH-z","expandIcon":"DH-z"};